


<div class="d-none d-lg-block">
  <app-loader *ngIf="loading"></app-loader>
  <ng-container *ngIf="!loading">
    <ng-container *ngIf="workflowSaves && workflowSaves.length == 0">
      <i>
        There are no pending workflows to display.
      </i>
    </ng-container> 
    <ng-container *ngIf="workflowSaves && workflowSaves.length > 0">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Name</th>
            <th>Created By</th>
            <th>Last Saved By</th>
            <th>Action</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let workflowSave of workflowSaves">
            <td>{{ workflowSave.sourceWorkflowName }}</td>
            <td>{{ workflowSave.createdBy }}</td>
            <td>{{ workflowSave.modifiedBy }}</td>
            <td>{{ workflowSave.detailedAction }}</td>
            <td>
              <button 
                *ngIf="workflowSave.action === WorkflowConfigurationSaveAction.Import"
                class="btn btn-primary btn-raised mr-2" 
                [routerLink]="[
                  '/admin/jurisdiction', 
                  _context?.client?.id, 
                  'workflows', 
                  'import',
                  workflowSave.sourceWorkflowId,
                  workflowSave.id
                ]"
              >
                Resume
              </button>
              <button 
                *ngIf="workflowSave.action === WorkflowConfigurationSaveAction.Copy"
                class="btn btn-primary btn-raised mr-2" 
                [routerLink]="[
                  '/admin/jurisdiction', 
                  _context?.client?.id, 
                  'workflows', 
                  'copy',
                  workflowSave.sourceWorkflowId,
                  'resume',
                  workflowSave.id
                ]"
              >
                Resume
              </button>
              <wm-modal-confirm 
                title="Delete Pending Workflow" 
                buttonText="Delete" 
                commandText="Yes" 
                [showButton]="true"
                [showButtonText]="true" 
                (accepted)="deletePending(workflowSave.id)"
              >
                <p>This will clear out the configuration for this pending workflow copy/import.</p>
                <p>Do you want to continue?</p>
              </wm-modal-confirm>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </ng-container>
</div>

<!-- Cards for tablet and phone -->
<div class="d-lg-none">
  <app-loader *ngIf="loading"></app-loader>
  <ng-container *ngIf="!loading">
    <ng-container *ngIf="workflowSaves && workflowSaves.length == 0">
      <i>
        There are no pending workflows to display.
      </i>
    </ng-container>
    <ng-container *ngIf="workflowSaves && workflowSaves.length > 0">
      <div *ngFor="let workflowSave of workflowSaves" class="card mb-3">
        <div class="card-body">
          <h5 class="card-title">{{ workflowSave.sourceWorkflowName }}</h5>
          <p class="card-text mb-1"><strong>Created By:</strong> {{ workflowSave.createdBy }}</p>
          <p class="card-text mb-1"><strong>Last Saved By:</strong> {{ workflowSave.modifiedBy }}</p>
          <p class="card-text mb-2"><strong>Action:</strong> {{ workflowSave.detailedAction }}</p>
          <button 
            *ngIf="workflowSave.action === WorkflowConfigurationSaveAction.Import"
            class="btn btn-primary btn-block btn-raised" 
            [routerLink]="[
              '/admin/jurisdiction', 
              _context?.client?.id, 
              'workflows', 
              'import',
              workflowSave.sourceWorkflowId,
              workflowSave.id
            ]"
          >
            Resume
          </button>
          <button 
            *ngIf="workflowSave.action === WorkflowConfigurationSaveAction.Copy"
            class="btn btn-primary btn-block btn-raised" 
            [routerLink]="[
              '/admin/jurisdiction', 
              _context?.client?.id, 
              'workflows', 
              'copy',
              workflowSave.sourceWorkflowId,
              'resume',
              workflowSave.id
            ]"
          >
            Resume
          </button>
          <wm-modal-confirm 
            title="Delete Pending Workflow" 
            buttonClass="btn btn-primary btn-raised btn-block"
            buttonText="Delete" 
            commandText="Yes" 
            [showButton]="true" 
            [showButtonText]="true"
            (accepted)="deletePending(workflowSave.id)"
          >
            <p>This will clear out the configuration for this pending workflow copy/import.</p>
            <p>Do you want to continue?</p>
          </wm-modal-confirm>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

